
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[productid]",
      function () {
        return require("private-next-pages/product/[productid]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[productid]"])
      });
    }
  